/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-09-14 15:28:14
 * @LastEditors: mojiangpeng 125392435@qq.com
 * @LastEditTime: 2024-03-01 16:01:36
 */
import router from "./router";
import store from "./store/";
import { cache } from "@/utils/common";

// const whiteList = ["login"]; //路由白名单.

router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === "development") {
    cache.set("user", {
      openId: "omUQcxFHtI8LAIDVs_dmOqnQYzgM",
      bookingPaymentMode: 1, //
      token:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzX3dlY2hhdF9vcGVuaWQiOiJ3ZWNoYXJfdGVzdF9vcGVuaWQiLCJuYmYiOiIxNzA5Mjc5OTY2IiwiZXhwIjoiMTcwOTI4NzE2NiIsImlzcyI6Im9wdV9iaGl3eCIsImF1ZCI6Im9wdV9iaGl3eCJ9.17p5USa5sfJ_GDwH9m7CD5MHIab44URJN2g2eWskgTw",
      wxHeadImgUrl:
        "http://thirdwx.qlogo.cn/mmopen/vi_32/ZunaDIIwlPuPWiaH0GDS6dEHw9ice3Nf7v12qRBLT9bibAh40xl5TZQ3uSwfmStFWYfwgqz5oPKibxwXH18BicvniaUQ/132",
      wxNickName: "A 黄岗 ~ 互联网开发",
      enabledMobileTodayRegistration: true,
      enabledMobileBookingRegistration: true,
      enabledMobileMyInHospital: true,
    });
  }
  const user = cache.get("user");
  if (!user) {
    store.dispatch("login", to).then(() => {
      next({
        ...to,
      });
    });
  } else {
    next();
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

router.afterEach(() => {});
